import React from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import { ACTIVE } from "../constant/constant";
import emptyImg from "../assets/images/empty.png"

/**
 * ##Protected Route Components
 * @returns
 */
export const PrivateRoutes = () => {
  const auth = localStorage.getItem("token");
  return auth ? (
    <>
      <Navigate to={"/dashboard"} />
      <Outlet />
    </>
  ) : (
    <Navigate to={"/login"} />
  );
};

export const NewPrivateRoute = ({ children, ...rest }) => {
  const auth = localStorage.getItem("token");
  return <Route {...rest}>{auth ? children : <Navigate to="/login" />}</Route>;
};

/**
 * ##Validation Message Handling
 * @param {*} param0
 * @returns
 */
export const ValidationMessage = ({ error, name }) => {
  var message = "";
  if (error.hasOwnProperty(name)) {
    message = error[name][0];
  }
  return <span className="text-danger">{message}</span>;
};

/**
 * ## Pagination Component
 * @param {*} param
 * @returns
 */

export const Pagination = ({ paginator, page, perPage, setPerPage }) => {
  if (!paginator) return null;

  const displayRange = 5;
  const halfRange = Math.floor(displayRange / 2);

  const current = paginator.current;
  const last = paginator.last;
  const total = paginator.total;

  // Calculate items per page from total/last
  const itemsPerPage = perPage || Math.ceil(total / last);

  // Calculate the "Showing X to Y of Z" range
  const from = (current - 1) * itemsPerPage + 1;
  const to = Math.min(current * itemsPerPage, total);

  const startPage = Math.max(1, current - halfRange);
  const endPage = Math.min(last, startPage + displayRange - 1);

  const handlePerPageChange = (e) => {
    const newPerPage = parseInt(e.target.value);
    setPerPage && setPerPage(newPerPage);
    page(1); // reset to first page when rows per page changes
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
      {/* Left side text */}
      <div className="ms-3 mb-2">
        <span>
          Showing {from} to {to} of {total} entries
        </span>
      </div>

      {/* Right side pagination & dropdown */}
      <div className="d-flex align-items-center mb-2">

        {/* Rows per page dropdown */}
        <div className="me-3">
          <label className="me-2">Show</label>
          <select
            className="form-select d-inline-block w-auto"
            value={itemsPerPage}
            onChange={handlePerPageChange}
          >
            {[10, 25, 50, 100].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
          <span className="ms-2">rows per page</span>
        </div>
        {/* Rows per page dropdown */}

        <nav aria-label="Page navigation mt-3">
          <ul className="pagination justify-content-end me-3 mt-3">
            <li
              className="page-item prev"
              onClick={() => page(Math.max(1, paginator.current - 1))}
            >
              <div className="page-link">
                <i className="tf-icon bx bx-chevrons-left"></i>
              </div>
            </li>
            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
              <li
                key={startPage + i}
                onClick={() => page(startPage + i)}
                className={
                  paginator.current === startPage + i ? "page-item active" : "page-item"
                }
              >
                <div className="page-link">{startPage + i}</div>
              </li>
            ))}
            <li
              className="page-item next"
              onClick={() => page(Math.min(paginator.last, paginator.current + 1))}
            >
              <div className="page-link">
                <i className="tf-icon bx bx-chevrons-right"></i>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};
/**
 * ## set badge class active while data status is Active
 * @param {*} status
 * @returns
 */
export const setBadgeClass = (status) => {
  if (status === ACTIVE) return "badge bg-label-info me-1";
  return "badge bg-label-warning me-1";
};

/**
 * Table Data Not Found means show the message
 * @param {*} param0
 * @returns
 */
// export const NoDataFound = ({ front, back, message }) => {
//   return (
//     <tr>
//       <td colSpan={front}> </td>
//       <td>{message}</td>
//       <td colSpan={back}> </td>
//     </tr>
//   );
// };

export const NoDataFound = ({ colspan, message }) => {
  return (
    <tr>
      <td className="center" colSpan={colspan}>{message}</td>
    </tr>
  );
};

export const NoUserFound = () => {
  return (
    <>
      <div className="not-found">
        <img src={emptyImg} />
        <span className="center">No data found!</span>
      </div>

    </>
  );
};

/**
 * frame the react select options
 * @param {*} data
 * @param {*} key
 * @param {*} value
 * @returns
 */
export const frameDataOptions = (data, key, value) => {
  if (data.length > 0) {
    return data.map((rs) => ({ value: rs[key], label: rs[value] }));
  }
  return [];
};

/**
 * selected the react-select value pluck
 * @param {*} data
 * @returns
 */
export const pluckValue = (data) => {
  let response = [];
  if (data.length > 0) {
    data.forEach((value) => response.push(value.value));
  }
  return response;
};

export const checkEmptyOrNull = (data) => {
  return data !== "" && data !== null && data !== undefined ? data : "-";
};

export const weekDaysInText = (day) => {
  let day_text = "";
  if (day === 0) day_text = "Sunday";
  else if (day === 1) day_text = "Monday";
  else if (day === 2) day_text = "Tuesday";
  else if (day === 3) day_text = "Wednesday";
  else if (day === 4) day_text = "Thursday";
  else if (day === 5) day_text = "Friday";
  else if (day === 6) day_text = "Saturday";
  return day_text;
}

export const WrapText = (text, maxLength) => {
  const words = text.split(' ');

  let currentLength = 0;
  let wrappedText = [];

  for (const word of words) {
    if (currentLength + word.length > maxLength) {
      wrappedText.push(<br key={wrappedText.length} />);
      currentLength = 0;
    }

    wrappedText.push(word + ' ');
    currentLength += word.length + 1; // 1 is for the space between words
  }

  return wrappedText;
};

export const hasRole = (roles) => {
  if (!Array.isArray(roles)) return false;
  const auth_user = JSON.parse(localStorage.getItem("user"));
  if (roles.includes(auth_user?.user_type)) {
    return true;
  } else {
    return false;
  }
}

export const getRoleName = (user_type) => {
  if(user_type === 1){
    return "Super Admin";
  }else if(user_type === 6){
    return "Country Admin";
  }else if(user_type === 7){
    return "State Admin";
  }else if(user_type === 2){
    return "Region Admin";
  }else if(user_type === 3){
    return "Chapter Admin";
  }else if(user_type === 4){
    return "Member";
  }else{
    return "";
  }
}